import script from "./StartASRView.vue?vue&type=script&setup=true&lang=js"
export * from "./StartASRView.vue?vue&type=script&setup=true&lang=js"

import "./StartASRView.vue?vue&type=style&index=0&id=08d0fec6&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d0fec6"]])

export default __exports__